import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import AssetsService from '../../services/AssetsService';

const Loading = () => {
  const navigate = useNavigate();
  const [progress, setProgress] = useState(20);

  const { data: locations, isSuccess } = useQuery({
    queryKey: ['locations'],
    queryFn: () => AssetsService.getLocations(),
    select: (data) => data.locations,
  });

  useEffect(() => {
    // Guard on isSuccess only: a teammate with no site yet (or an API response
    // without a `locations` key) leaves `locations` empty/undefined, and gating
    // on it would leave this screen spinning forever.
    if (!isSuccess) return;

    if (locations?.length === 1) {
      navigate(`/site/${locations[0].id}`, { replace: true });
    } else {
      navigate('/sites', { replace: true });
    }
  }, [isSuccess, locations, navigate]);

  useEffect(() => {
    const start = Date.now();
    const duration = 3000;
    const from = 20;
    const to = 90;

    const frame = () => {
      const elapsed = Date.now() - start;
      const t = Math.min(elapsed / duration, 1);
      const eased = 1 - (1 - t) * (1 - t); // easeOutQuad
      setProgress(from + (to - from) * eased);
      if (t < 1) requestAnimationFrame(frame);
    };

    const id = requestAnimationFrame(frame);
    return () => cancelAnimationFrame(id);
  }, []);

  return (
    <div className="w-full h-screen bg-secondary-900 inline-flex flex-col justify-center items-center">
      <div className="self-stretch flex-1 px-32 flex flex-col justify-center items-center">
        <div className="self-stretch flex flex-col justify-center items-center gap-24">
          <div className="inline-flex justify-start items-center gap-9">
            <div className="text-white typo-display">Follow</div>
          </div>
          <div className="w-[720px] max-w-full h-4 bg-white-alpha-10 rounded-2xl relative overflow-hidden">
            <div
              className="h-4 bg-primary-500 rounded-2xl transition-none"
              style={{ width: `${progress}%` }}
            />
          </div>
          <div className="text-white-alpha-80 typo-h3">
            Chargement de vos stations...
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loading;
